/**
 * 알람 스냅샷 질의의 **인자 한 벌** — 알람 화면과 헤더 배지가 **같은 것을 쓴다.**
 *
 * 🔴 **왜 상수로 뺐나.** 두 자리가 `GET /alarms` 를 부르는데 인자가 한 글자라도 다르면
 *    캐시 키(`keys.alarms.list(args)`)가 갈려 **같은 목록을 두 번 받는다.** 헤더는 모든
 *    화면에 떠 있으므로 그 왕복이 화면마다 는다. 한 벌을 나눠 쓰면 요청은 **한 번**이고,
 *    구독 무효화(`stream/bridge.ts` 의 `alarm` → `keys.alarms.all()`)도 둘을 한 번에 깨운다.
 *
 * 🔴 **주기 폴링이 아니다**(DP-01). 스냅샷 1회 + 구독 무효화다.
 *
 * ⚠ **`state=active` 로 좁혀 받지 않는다.** 서버에 그 축이 있지만(실측 — `state` ·
 *   `severity` · `source`) 좁히면 알람 화면이 쓰는 전체 목록과 **다른 캐시**가 되어
 *   왕복이 하나 는다. 받은 목록에서 세는 쪽을 골랐다 — 세는 규칙은 `useAlarmBadge.ts` 다.
 */
export interface AlarmSnapshotArgs {
  limit: number
}

/**
 * `GET /alarms` 를 한 번에 받는 상한(서버 최대 500 · `openapi.json` 실측).
 *
 * 🔴 **이 값에 「센 수의 진실성」이 걸린다.** 화면도 배지도 받은 것을 나눠 세므로,
 *    덜 받았으면 그 수가 거짓이 된다. 둘 다 `total_count` 와 맞춰 보고 **덜 받았으면
 *    「최소 N건」이라고 말한다**(지어내지 않는다).
 */
export const ALARM_PAGE_LIMIT = 500

/** 두 자리가 그대로 넘기는 인자. 🔴 **여기서 만든 객체를 새로 짓지 마라** — 키가 갈린다 */
export const ALARM_SNAPSHOT_ARGS: AlarmSnapshotArgs = { limit: ALARM_PAGE_LIMIT }
